/**
 * Утилита для вычисления номеров приложений к договору
 * Номера зависят от того, какие акты включены
 */

/**
 * Вычисляет номер приложения для акта приема-передачи жилого помещения
 * Всегда возвращает 1
 */
export const getHandoverActNumber = () => 1;

/**
 * Вычисляет номер приложения для акта приема-передачи денежных средств
 * Возвращает 2, если акт включен (наличный расчет)
 */
export const getMoneyTransferActNumber = (contractData) => {
  const paymentMethod = contractData?.payment?.paymentMethod || {};
  return paymentMethod.type === 'cash' ? 2 : null;
};

/**
 * Вычисляет номер приложения для акта возврата жилого помещения
 * Возвращает 2, если акт передачи денежных средств не включен, иначе 3
 */
export const getReturnActNumber = (contractData) => {
  const paymentMethod = contractData?.payment?.paymentMethod || {};
  const hasMoneyTransferAct = paymentMethod.type === 'cash';
  return hasMoneyTransferAct ? 3 : 2;
};

/**
 * Получает все номера приложений для актов
 * @returns {Object} Объект с номерами приложений
 */
export const getAllAttachmentNumbers = (contractData) => {
  return {
    handoverAct: getHandoverActNumber(),
    moneyTransferAct: getMoneyTransferActNumber(contractData),
    returnAct: getReturnActNumber(contractData)
  };
};

